import React from 'react'

import queryString from 'query-string'

import { Button, Col, Row, Portlet, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import EstadosTransferenciasConstant from 'constants/estadosTransferencias'
import TiposDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'
import { TiposTransferenciaConstant } from 'constants/index'

import * as TransfereciaService from 'services/transferencia.service'

import { DateHandler, DownloadAxiosFile } from 'utils'

import FechaEmisionFormGroup from './formGroups/fechaEmision'
import IdSedeOrigenFormGroup from './formGroups/idSedeOrigen'
import EstadoFormGroup from './formGroups/estado'

const portletBreadcrumbs = [{ name: 'Transferencias por Entrada' }]

const TransferenciasPorEntradaPage = ({ location, history }) => {
  const tablaRef = React.useRef(null)

  const initialQueryParams = React.useMemo(() => {
    if (location.search) {
      const parsed = queryString.parse(location.search)
      return parsed
    } else {
      return {}
    }
  }, [location.search])

  const fechaDefault = React.useMemo(() => {
    const nuevaFecha = DateHandler.format(new Date())
    return nuevaFecha
  }, [])

  const [fechaEmision, setFechaEmision] = React.useState(initialQueryParams.fe || fechaDefault)
  const [idSedeOrigen, setIdSedeOrigen] = React.useState(initialQueryParams.idso || '')
  const [estado, setEstado] = React.useState(initialQueryParams.e || EstadosTransferenciasConstant.RECEPCION_PENDIENTE)

  const clickBuscarHandler = () => {
    const queryParams = queryString.stringify({
      idso: idSedeOrigen,
      fe: fechaEmision,
      e: estado
    })
    history.push(`/${CodigosTransaccionesConstant.TRANSFERENCIAS_ENTRADA_LISTA}?${queryParams}`)
    tablaRef.current.reload({
      idSedeOrigen: idSedeOrigen,
      fechaEmision: fechaEmision,
      estado: estado
    })
  }

  const clickVerDetalles = ({ _id }) => {
    const queryParams = queryString.stringify({
      idso: idSedeOrigen,
      fe: fechaEmision,
      e: estado
    })
    history.push(`/${CodigosTransaccionesConstant.TRANSFERENCIAS_ENTRADA_DETALLE}/${_id}?${queryParams}`)
  }

  const clickImprimirRecepcionxId = React.useCallback(async ({ _id }) => {
    await TransfereciaService.imprimirRecepcionxId(_id).then(({ data, headers }) => {
      DownloadAxiosFile.downloadAsBlob(data, headers)
    })
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Transferencias por Entrada' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row className='p-3'>
            <Col md={3}>
              <FechaEmisionFormGroup value={fechaEmision} onChange={e => setFechaEmision(e.target.value)} />
            </Col>
            <Col md={3}>
              <IdSedeOrigenFormGroup value={idSedeOrigen} onChange={e => setIdSedeOrigen(e.target.value)} />
            </Col>
            <Col md={3}>
              <EstadoFormGroup value={estado} onChange={e => setEstado(e.target.value)} />
            </Col>
            <Col md={3}>
              <Button className='ml-2' onClick={clickBuscarHandler}>
                Buscar
              </Button>
            </Col>
          </Row>
          <Table.ServerSide
            ref={tablaRef}
            useNest={true}
            url='/transferencias'
            baseParams={{
              tipoConsulta: TiposTransferenciaConstant.ENTRADA,
              idSedeOrigen: idSedeOrigen,
              fechaEmision: fechaEmision,
              estado: estado
            }}
            headRows={[
              { label: 'FEC. EMISION' },
              { label: 'TIPO DOCUMENTO' },
              { label: 'DOCUMENTO' },
              { label: 'ESTABLECIMIENTO ORIGEN' },
              { label: 'USUARIO' },
              { label: 'ESTADO' },
              { label: '' }
            ]}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell>{row.fechaEmision || '--'}</Table.Cell>
                <Table.Cell>
                  {row.tipoDocumento ? TiposDocumentoSunatConstant.__dictionary[row.tipoDocumento].nombre : '--'}
                </Table.Cell>
                <Table.Cell>
                  {row.serieDocumento || '--'} - {row.numeroDocumento || '--'}
                </Table.Cell>
                <Table.Cell>{row.sedeOrigen || '--'}</Table.Cell>
                <Table.Cell>{row.usuario || '--'}</Table.Cell>
                <Table.Cell>
                  {row.estadoRecepcion ? EstadosTransferenciasConstant.__dictionary[row.estadoRecepcion].nombre : '--'}
                </Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item
                        key='imprimirPdf'
                        handleClose={handleClose}
                        onClick={e =>
                          clickVerDetalles({
                            _id: row._id
                          })
                        }
                      >
                        Ver Detalles
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='imprimirRecepcion'
                        handleClose={handleClose}
                        onClick={e =>
                          clickImprimirRecepcionxId({
                            _id: row._id
                          })
                        }
                      >
                        Imprimir
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default TransferenciasPorEntradaPage
